import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';

export const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already accepted cookies
        const hasAccepted = localStorage.getItem('cookieConsentAccepted');
        if (!hasAccepted) {
            // Show banner after a short delay for better UX
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsentAccepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-banner" role="alert" aria-live="polite">
            <div className="cookie-consent-content">
                <div className="cookie-icon">
                    <Cookie size={24} />
                </div>
                <div className="cookie-text">
                    <p>
                        We use cookies to enhance your experience, analyze site usage, and remember your preferences.
                        By continuing to use CutIQ, you consent to our use of cookies.{' '}
                        <Link to="/privacy" className="cookie-link">
                            Learn more
                        </Link>
                    </p>
                </div>
                <button
                    onClick={handleAccept}
                    className="cookie-accept-btn"
                    aria-label="Accept cookies"
                >
                    Accept
                </button>
                <button
                    onClick={handleAccept}
                    className="cookie-close-btn"
                    aria-label="Close cookie notice"
                >
                    <X size={20} />
                </button>
            </div>
        </div>
    );
};
